document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".faq-item");

    items.forEach(item => {
        if (item) {
            item.addEventListener("click", () => {
                if (item.classList.contains("active")) {
                    item.classList.remove("active");
                } else {
                    items.forEach(i => i.classList.remove("active"));
                    item.classList.add("active");
                }
            });
        }
    });
});